import Accordion from "../Accordion"
import { BulletTabs } from "../BulletTabs"
import { Button } from "../Button"
import { CheckBox } from "../Form"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../Modal"
import { NewModal, NewModalBody, NewModalFooter, NewModalHeader } from "../NewModal"
import { StepFields } from "../StepFields"
import './styles.scss';

export const ModalAddForm = ({
  modalAddFormIsOpen,
  handleCloseFormModal,
  indicatorTabsOptions,
  handleActiveIndicator,
  formSteps,
  checkedSteps,
  handleChangeChecked,
  handleAddSteps
}) => {
  const AccordionHeader = ({ title, name }) => {
    return (
      <>
        <div className="add-form-accordion__header">
          <div className="checkbox">
            <CheckBox
              name={name}
              onChange={handleChangeChecked}
              checked={checkedSteps[name]?.value}
            />
          </div>
          <span>{title}</span>
        </div>
      </>
    )
  }

  return (
    <ModalPanel modalIsOpen={modalAddFormIsOpen} shouldCloseOnOverlayClick={true} width={900}>
      <ModalHeader closeModal={handleCloseFormModal}>
        <h3 className="add-form-modal-tile">Adicionar formulário</h3>
      </ModalHeader>
      <ModalBody hideScroll className="add-form-modal-body">
        <div className="form-tabs">
          <BulletTabs options={indicatorTabsOptions} onSelect={handleActiveIndicator} />
        </div>
        <h3>{formSteps && formSteps[0]?.name}</h3>
        {formSteps &&
          formSteps[0]?.groups.map(({ title, id, questions }, index) => {
            return (
              <Accordion
                key={index}
                index={index}
                id={Math.random()}
                header={<AccordionHeader title={title} name={id} />}>
                <StepFields fields={questions || []} />
              </Accordion>
            )
          })}
      </ModalBody>
      <ModalFooter styles={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
        <div className="modal-button-footer">
          <Button label="Cancelar" variant="ghost" handleClick={handleCloseFormModal}/>
        </div>
        <div className="modal-button-footer">
          <Button
            label="Adicionar"
            handleClick={handleAddSteps}
            isDisabled={!Object.keys(checkedSteps).filter(step => checkedSteps[step]?.value).length}
          />
        </div>
      </ModalFooter>
    </ModalPanel>
  )
}